/**
 * Handles the visibility and behavior of the sticky header for the Emu variant.
 */
export const initStickyHeaderEmu = (): void => {
  const stickyBar = document.querySelector<HTMLElement>(
    ".site-header-sticky--emu",
  );

  if (!stickyBar) {
    return;
  }

  // Define when the sticky header drops down (e.g., after 250px)
  const scrollThreshold = 250;
  let isStickyActive = false;

  const toggleStickyHeader = () => {
    const shouldBeActive = window.scrollY > scrollThreshold;

    if (shouldBeActive !== isStickyActive) {
      isStickyActive = shouldBeActive;

      if (isStickyActive) {
        stickyBar.classList.add("is-visible");
      } else {
        stickyBar.classList.remove("is-visible");
      }
    }
  };

  // Listen to scroll events (passive for better scroll performance)
  window.addEventListener("scroll", toggleStickyHeader, { passive: true });

  // Run once on load just in case the user refreshes mid-page
  toggleStickyHeader();

  console.log("[StickyHeaderEmu] Initialized.");
};
